// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type LightBulb24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const LightBulb24CircleFilled: FC<LightBulb24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-1.412-6.587c.391.391.862.587 1.412.587.55 0 1.02-.196 1.413-.587.391-.392.587-.863.587-1.413h-4c0 .55.196 1.02.588 1.413ZM12 21v2h8v-2h-8Zm-2.487-3.75A7.662 7.662 0 0 0 12.25 20h7.5a7.662 7.662 0 0 0 2.738-2.75A7.278 7.278 0 0 0 23.5 13.5c0-2.083-.73-3.854-2.188-5.313C19.855 6.73 18.084 6 16 6s-3.854.73-5.313 2.188C9.23 9.646 8.5 11.416 8.5 13.5c0 1.35.337 2.6 1.013 3.75Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default LightBulb24CircleFilled;
